import { Theme, styled } from '@material-ui/core';

const TooltipPrimaryColorText = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.primary.light,
  fontWeight: 700,
}));

export default TooltipPrimaryColorText;
